<template>
  <div class="withdraw">
    <div class="bg-white">
      <div class="flex items-center tab shadow-border-b mdmax:overflow-x-auto">
        <div
          class="relative px-6 py-3 cursor-pointer text-center font-medium"
          v-for="(tab, index) in tabList"
          :key="'tab-' + index"
          :class="[tab.active ? 'active text-neutral-700' : 'text-neutral-500']"
          @click="selectTab(tab)"
        >
          {{ tab.title }}
        </div>
      </div>
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <div v-if="column.field === 'bank'">
          <p class="text-sm">{{ entry.driver.bankName }}</p>
          <p class="text-xs text-neutral-500">{{ entry.driver.bank_account_number }} - {{ entry.driver.bank_account_owner }}</p>
        </div>
        <div v-else-if="column.field === 'status'">
          <p class="rounded-md inline-block text-xs py-1 px-2 bg-system-warning text-white">{{ entry.status }}</p>
        </div>
        <span v-else-if="column.field === 'driverName'">{{ entry.driver.name }}</span>
        <span v-else>{{ entry[column.field] || '-' }}</span>
      </template>
    </TableComponent>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}</div>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
  },
  data() {
    return {
      tabList: [
        {
          title: 'Semua',
          active: true
        },
        {
          title: 'Process',
          active: false
        },
        {
          title: 'Setujui',
          active: false
        }
      ],
      selectedTab: '',
      columns: [
        { label: 'Tanggal', field: 'date' },
        { label: 'Status', field: 'status' },
        { label: 'Request ID', field: 'requestId' },
        { label: 'Nama Driver', field: 'driverName' },
        { label: 'Bank Info', field: 'bank' },
        { label: 'Nominal', field: 'nominal' }
      ],
      data: [
        {
          date: '16 Oct 2021',
          status: 'Process',
          requestId: 'LN-5631',
          driver: {
            name: 'Jujung Gunawan',
            bankName: 'PT. BCA ( Bank Central Asia )',
            bank_account_number: '623131239231',
            bank_account_owner: 'Rizky Jainudin Kusnaedi'
          },
          nominal: 'Rp 300.000'
        }
      ],
      searchTerm: '',
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      hasMorePages: true
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    filteredData() {
      return this.data
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  mounted() {
    this.selectTab(this.tabList[0])
  },
  created() {
    if (!this.$route.query.page) {
      this.$router.push({ path: '/finance/withdraw', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getCourierBalanceInfo()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getCourierBalanceInfo()
      } else {
        this.$router.push({ path: '/finance/withdraw', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  },
  methods: {
    ...mapActions('courier', ['getCourierBalance']),
    selectTab(tab) {
      this.tabList.forEach(item => (item.active = false))
      const tabIndex = this.tabList.findIndex(item => item.title === tab.title)
      this.tabList[tabIndex].active = true
      this.selectedTab = tab
    },
    onPageChange(page) {
      this.currentPage = page
    },
    getCourierBalanceInfo(searchTerm = '') {
      this.getCourierBalance({
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: searchTerm,
          sort: 'ASC',
          status: '',
          type: 'EARNING'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tab {
  .active {
    &::after {
      content: '';
      display: block;
      height: 4px;
      width: 100%;
      background-color: #61d7cf;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
}
</style>
